module.exports = __webpack_public_path__ + "static/banner-update-data-cl-c2b570f54e54bb8c699c81536cd78ee7.png";